<report-filter
  showCostCenters='true'
  showFacilities='true'
  showPeriodEndDateSelection='true'
  defaultPayPeriodsBack=4
  reportType='inpatient'
  [(defaultFilter)]="filters"
  (filterUpdated)="filterUpdated($event)">
</report-filter>

<table class="reportArea">
 <tr>
    <td class="reportPanel">
    <smt-performancereport
      [filtersUpdated]='eventsSubject.asObservable()'
      [(reportFilters)]='filters'>
    </smt-performancereport>
  </td>
  <td class="reportPanel">
    <smt-dailychurnratereport
      [filtersUpdated]='eventsSubject.asObservable()'
      [(reportFilters)]='filters'>
    </smt-dailychurnratereport>
  </td>
 </tr>
</table>
<table class="reportArea bottomReportArea">
 <tr>
  <td id='smt-measures-panel' class="reportPanel">
    <smt-measures-report
      [filtersUpdated]='eventsSubject.asObservable()'
      [(reportFilters)]='filters'>
    </smt-measures-report>
  </td>
  <td class="reportPanel smt-variance-panel">
    <smt-reasonsforvariancereport
      [filtersUpdated]='eventsSubject.asObservable()'
      [(reportFilters)]='filters'>
    </smt-reasonsforvariancereport>
  </td>
 </tr>
</table>
